import { FC } from 'react'

import { Card, CardContent } from '../../ui/card'
import customImageComponent from '../../common/CustomImageComponent'

import { getFloatPrice } from '../../../helpers/price'

interface SubPaymentMemberProps {
  recipient: {
    recipientPicture: string | null
    recipientName: string | null
    amountToPay: number | null
  }
  currency: string
}
export const SubPaymentMember: FC<SubPaymentMemberProps> = ({ recipient, currency }) => {
  return (
    <Card className="flex-1 rounded-lg sm:min-w-[31%] shadow-none">
      <CardContent className="p-2 flex items-center h-full">
        <div className="flex gap-2 items-center flex-1">
          <div className="w-[45px] min-w-[45px] h-[45px] rounded-lg overflow-hidden border border-black/10">
            {customImageComponent(
              recipient?.recipientPicture,
              recipient?.recipientName,
              'w-full h-full'
            )}
          </div>
          <div>
            <h4 className="text-sm">{recipient.recipientName}</h4>
            <p className="font-bold text-xs">
              {getFloatPrice(`${currency}${recipient?.amountToPay}`)}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
